export const CODIGO_TIPO_IDENTIFICADOR_ESCOLA_CEL = 6;

/**
 * Obtém o dia da semana (0=dom … 6=sáb) da data escolhida no calendário (datetime-local),
 * sem deslocamento de fuso que altere o dia exibido.
 */
export function obterDiaSemanaDaDataSelecionada(dataChamado: string | Date): number | null {
  if (dataChamado == null || dataChamado === '') {
    return null;
  }

  if (typeof dataChamado === 'string') {
    const datePart = dataChamado.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
      const [year, month, day] = datePart.split('-').map(Number);
      return new Date(year, month - 1, day).getDay();
    }
  }

  const data = dataChamado instanceof Date ? dataChamado : new Date(dataChamado);
  if (isNaN(data.getTime())) {
    return null;
  }

  return new Date(data.getFullYear(), data.getMonth(), data.getDate()).getDay();
}

/**
 * Valida o dia da semana da data selecionada no calendário (passada, hoje ou futura).
 * Escolas CEL (tipo 6): segunda a sábado. Demais: segunda a sexta. Domingo: bloqueado para todas.
 */
export function validarDataOcorrenciaChamado(
  dataChamado: string | Date,
  codigoTipoIdentificador?: number | null
): string | null {
  const dia = obterDiaSemanaDaDataSelecionada(dataChamado);

  if (dia === null) {
    return 'Informe uma data e hora válida.';
  }

  const isEscolaCEL = codigoTipoIdentificador === CODIGO_TIPO_IDENTIFICADOR_ESCOLA_CEL;

  if (dia === 0) {
    return 'Não é permitido registrar chamados aos domingos.';
  }

  if (!isEscolaCEL && dia === 6) {
    return 'Não é permitido registrar chamados aos sábados. Escolas regulares podem abrir chamados somente de segunda a sexta-feira.';
  }

  return null;
}
